import { FC } from 'react'

import { Field, SelectDropdown, Slider } from '@makyoapp/makyo-ui'

import { SectionBackgroundGroupProps } from '@/shared/builder/default/section.default'
import { validSliderValue } from '@/shared/utils'

interface OverlayBackgroundSelectProps {
  layer: SectionBackgroundGroupProps
  handleUpdate: (id: number, newValues: any) => Promise<void>
}

export const OverlayBackgroundSelect: FC<OverlayBackgroundSelectProps> = ({ handleUpdate, layer }) => {
  const opacity = validSliderValue((layer.values.opacity as number) ?? [0.5])

  return (
    <div className='space-y-4'>
      <SelectDropdown
        value={layer.values.enabled ? 'Enable Overlay' : 'No Overlay'}
        onChange={(e) =>
          handleUpdate(layer.id, {
            enabled: e === 'Enable Overlay',
            color: '#000000',
            opacity,
          })
        }
        options={['No Overlay', 'Enable Overlay']}
      />
      {layer.values.enabled && (
        <Field isVertical>
          <Slider
            min={0}
            max={1}
            step={0.05}
            values={[validSliderValue(opacity, 0, 1)[0]]}
            onChange={(e) => handleUpdate(layer.id, { opacity: e })}
            showLabel
          />
        </Field>
      )}
    </div>
  )
}
